import { logoutUrl } from "../constants/app.constants";
import { appConfig } from "../config/config";
import { store } from "../store";

const GENERIC_ERROR = "Something went wrong";

class CustomError extends Error {
    constructor(message, errors) {
        super(message);
        this.errors = errors;
    }
}

const createUrlParams = (params, encode) => {
    const esc = encodeURIComponent;
    const query = Object.keys(params)
        .map((k) => (encode ? esc(k) + "=" + esc(params[k]) : esc(k) + "=" + params[k]))
        .join("&");

    return query;
};

const handleResponse = (response) => {
    const contentType = response.headers.get("content-type");
    const isJson = contentType && contentType.indexOf("application/json") !== -1;
     
    if (response.ok) {
        if (isJson) {
            return response.json();
        }
        return response.text();
    } else {
        if (isJson) {
            return response.json().then((json) => {
                if (json.code === 440) {
                    window.parent.location.replace(logoutUrl);
                }
                const error = new CustomError(json.description || json.message || json.error_description || GENERIC_ERROR, json.errors);
                return Promise.reject(
                    Object.assign(error, {
                        response,
                    })
                );
            });
        } else {
            throw new Error(GENERIC_ERROR);
        }
    }
};

export const apiCall = async (requestType, url, customHeaders, requestBody, requestParams) => {
    const state = store.getState();
    const domainCode = state.currentUser?.response?.domainCode;
    let headers = {
        "Content-type": "application/json",
        "X-Interswitch-Authorization-Domain": domainCode,
        "Access-Control-Allow-Origin": "*",
        // "Authorization": "Bearer eyJhbGciOiJSUzI1NiJ9.eyJsYXN0TmFtZSI6IkFkZW51Z2EiLCJmaXJzdExvZ2luIjpmYWxzZSwidXNlcl9uYW1lIjoiQXlvd29sZS5BZGVudWdhIiwibW9iaWxlTm8iOiIyMzQ4MTAyNjUwNDM1IiwiY2xpZW50X2lkIjoiSUtJQTdCNjVFNThDMDFFMDA1NDE0Qjk3QkNCNkI2MjYzNkM4NUZCMkM5RjYiLCJmaXJzdE5hbWUiOiJBeW93b2xlIiwiZW1haWxWZXJpZmllZCI6dHJ1ZSwiYXVkIjpbImFyYml0ZXIiLCJjYWVzYXIiLCJjYXJkbGVzcy1zZXJ2aWNlIiwiaGltcy1wb3J0bGV0IiwiaXN3LWNvbGxlY3Rpb25zIiwiaXN3LWNvcmUiLCJpc3ctaW5zdGl0dXRpb24iLCJpc3ctcGF5bWVudGdhdGV3YXkiLCJwYXNzcG9ydCIsInByb2plY3QteC1tZXJjaGFudCIsInJlY3VycmVudC1iaWxsaW5nLWFwaSIsInJlZmVycmFsLXNlcnZpY2UtYXBpIiwidHJhbnNmZXItc2VydmljZS1hZG1pbiIsInRyYW5zZmVyLXNlcnZpY2UtY29yZSIsInZlcnZlLXJld2FyZC11aSIsIndhbGxldCIsIndlYnBheS1wb3J0bGV0Il0sInNjb3BlIjpbInByb2ZpbGUiXSwiZXhwIjoxNjI4MDYzNjU4LCJtb2JpbGVOb1ZlcmlmaWVkIjp0cnVlLCJjbGllbnRfbmFtZSI6ImNhcmRsZXNzLWNsaWVudCIsImp0aSI6IjQ2NmIwYTdmLTczNjctNDRkZC1hMWI2LTJmZGIwODBlYjc5YyIsImVtYWlsIjoiYXlvd29sZS5hZGVudWdhQGludGVyc3dpdGNoZ3JvdXAuY29tIiwicGFzc3BvcnRJZCI6IjYzMTMyODE5LThENzItMzA5MS1BRkM3LTVBNjQ1MzhEQUY0MiJ9.U1Kign5xPS29vREgrHiepTOvOG9kuXKGVe8L9gF_utueN-I2aW73cVWrFYrF_L0oGjLbU-oIXJDSYra0DT37iM8C2Apoq4mu_a9ea_TWOwk-aiFbcu0DdylXNq8y3cNl8SeRQ4cu_rcpEjRGhDOvHB7nyhf4y07HNu5do4cLUfCE-dM_iv1Fv998lsk-RyWCTwGoBaKhYnjsFZE2MD0IKs9PuXl9Qstj94xOUegLyXX0izNj06WXyaIMvYRFtivU61YEn0_DS3OrC-I4M7iItDRw-1WLxtjCWzu8c3EIuMrf4Vcb9SgF_orbPFoTh_wP-NO6j97wivxDOJH9ChAk2g",
        ...customHeaders,
    };

    const { xsrfToken, xsrfTokenHeader } = appConfig;

    if (xsrfToken && xsrfTokenHeader) {
        headers[xsrfTokenHeader] = xsrfToken;
    }

    const requestOptions = {
        method: requestType,
        headers,
        body: requestBody ? JSON.stringify(requestBody) : undefined,
    };
    if (requestParams) {
        const urlParams = createUrlParams(requestParams);
        url = `${url}?${urlParams}`;
    }

    return fetch(url, requestOptions).then(handleResponse);
};

export const apiCallForUpload = async (requestType, url, requestBody, requestParams) => {
    let headers = {};
    const { xsrfToken, xsrfTokenHeader } = appConfig;

    if (xsrfToken && xsrfTokenHeader) {
        headers[xsrfTokenHeader] = xsrfToken;
    }

    const requestOptions = {
        method: requestType,
        body: requestBody,
        headers,
    };
    if (requestParams) {
        const urlParams = createUrlParams(requestParams);
        url = `${url}?${urlParams}`;
    }
    return fetch(url, requestOptions).then(handleResponse);
};
